import { AuthParamsProtocol } from './authProtocols'
import CryptoJS from 'crypto-js'
import { get } from 'lodash'
import { fetcher } from 'services/fetcher'

const apiUrl = process.env.REACT_APP_MS_API_BASE_URL || ''
const authKey = process.env.REACT_APP_AUTH_KEY || ''

const authService = async (params: AuthParamsProtocol) => {
  const email = get(params, 'username', '')
  const password = get(params, 'password', '')

  const fetcherInstance = await fetcher()
  delete fetcherInstance?.defaults?.headers?.common['Authorization']

  return await fetcherInstance(`${apiUrl}/login`, {
    method: 'POST',
    data: { email, password },
  }).then((response) => {
    return {
      user: response?.data?.content?.instance,
      status: response?.status,
    }
  })
}

const isAuthenticated = async (): Promise<string> => {
  return new Promise((resolve) => {
    try {
      const ck = localStorage.getItem('_ck') || ''
      const bytes2 = CryptoJS.AES.decrypt(ck, authKey)
      const authToken = JSON.parse(bytes2.toString(CryptoJS.enc.Utf8))
      resolve(authToken)
    } catch (error) {
      // Dispatch error log
      resolve('')
    }
  })
}

const setAuthenticated = (token: string): void => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(token),
    authKey,
  ).toString()
  localStorage.setItem('_ck', ciphertext)
}

export { isAuthenticated, setAuthenticated, authService }
